import FinalPrice from "./FinalPrice";

export default FinalPrice;
